window.TTCartProgress = (() => {
  function getEligibleVariantIds() {
    if (
      Array.isArray(
        window.TT_BUNDLE_ELIGIBLE_VARIANT_IDS
      )
    ) {
      return window.TT_BUNDLE_ELIGIBLE_VARIANT_IDS.map(
        Number
      );
    }

    if (
      window.BundleBuilder &&
      typeof window.BundleBuilder
        .getBundleVariantIds === 'function'
    ) {
      return window.BundleBuilder
        .getBundleVariantIds()
        .map(Number);
    }

    return [];
  }

  function getBundleItems(cart) {
    if (!cart?.items) return [];

    const eligibleVariantIds =
      getEligibleVariantIds();

    if (!eligibleVariantIds.length) {
      return [];
    }

    return cart.items
      .filter((item) => {
        return eligibleVariantIds.includes(
          Number(item.variant_id)
        );
      })
    .reverse();
  }

  function getMessageParts(quantity, wrapper) {
    let messageTier;

    if (quantity >= 5) {
      messageTier = 5;
    } else if (quantity >= 4) {
      messageTier = 4;
    } else if (quantity >= 3) {
      messageTier = 3;
    } else if (quantity >= 2) {
      messageTier = 2;
    } else if (quantity >= 1) {
      messageTier = 1;
    } else {
      messageTier = 0;
    }

    return {
      line2:
        wrapper.getAttribute(
          `data-message-${messageTier}`
        ) || ''
    };
  }

  function getExpandedBundleItems(cart) {
    const expandedItems = [];

    getBundleItems(cart).forEach((item) => {
      for (
        let index = 0;
        index < item.quantity;
        index += 1
      ) {
        expandedItems.push(item);
      }
    });

    return expandedItems;
  }

  function createSquare() {
    const square =
      document.createElement('div');

    square.className =
      'cart-box-progress__square';

    square.setAttribute(
      'data-box-step',
      ''
    );

    const image =
      document.createElement('img');

    image.className =
      'cart-box-progress__image';

    image.setAttribute(
      'data-box-image',
      ''
    );

    image.alt = '';
    image.loading = 'lazy';
    image.width = 100;
    image.height = 100;

    square.appendChild(image);

    return square;
  }

  function updateBoxProgress(cart) {
    const expandedItems =
      getExpandedBundleItems(cart);

    const bundleQuantity =
      expandedItems.length;

    document
      .querySelectorAll(
        '[data-cart-box-progress]'
      )
      .forEach((wrapper) => {
        const squaresWrapper =
          wrapper.querySelector(
            '.cart-box-progress__squares'
          );

        if (squaresWrapper) {
          const targetSquareCount = Math.max(
            5,
            bundleQuantity
          );

          let squares = Array.from(
            squaresWrapper.querySelectorAll(
              '[data-box-step]'
            )
          );

          while (
            squares.length <
            targetSquareCount
          ) {
            squaresWrapper.appendChild(
              createSquare()
            );

            squares = Array.from(
              squaresWrapper.querySelectorAll(
                '[data-box-step]'
              )
            );
          }

          while (
            squares.length >
            targetSquareCount
          ) {
            squares[
              squares.length - 1
            ].remove();

            squares = Array.from(
              squaresWrapper.querySelectorAll(
                '[data-box-step]'
              )
            );
          }

          squares.forEach(
            (square, index) => {
              square.dataset.boxStep =
                String(index + 1);

              const item =
                expandedItems[index];

              const image =
                square.querySelector(
                  '[data-box-image]'
                );

              if (item && image) {
                image.src =
                  item.image ||
                  item.featured_image?.url ||
                  '';

                image.alt =
                  item.product_title ||
                  item.title ||
                  '';

                square.classList.add(
                  'is-complete',
                  'has-image'
                );
              } else {
                if (image) {
                  image.removeAttribute(
                    'src'
                  );

                  image.alt = '';
                }

                square.classList.remove(
                  'is-complete',
                  'has-image'
                );
              }
            }
          );
        }

        const line2El =
          wrapper.querySelector(
            '[data-cart-box-line]'
          );

        if (!line2El) return;

        const parts = getMessageParts(
          bundleQuantity,
          wrapper
        );

        if (parts.line2) {
          line2El.textContent =
            parts.line2;
        }
      });
  }

  function update(cart) {
    if (!cart) return;

    updateBoxProgress(cart);
  }

  async function sync() {
    if (!window.TTCart) return;

    try {
      const cart =
        await window.TTCart.fetchCart();

      update(cart);
    } catch (error) {
      console.error(
        'Cart progress could not sync:',
        error
      );
    }
  }

  document.addEventListener(
    'cart:change',
    (event) => {
      if (event?.detail?.cart) {
        update(event.detail.cart);
      } else {
        sync();
      }
    }
  );

  document.addEventListener(
    'cart:refresh',
    sync
  );

  document.addEventListener(
    'DOMContentLoaded',
    sync
  );

  document.addEventListener(
    'shopify:section:load',
    sync
  );

  return {
    update,
    sync
  };
})();